import angular from 'angular';
import common from 'app/modules/common';
import heroTemplate from './views/hero.html';
import service from './services/physical';
import deliveryCreateFlowCfg from './states/delivery/create/flow';
const ngModule = angular.module('app.holding.dashboard.physical', [
    common,
]);
const deliveryCfg = require('./states/delivery/delivery');
const deliveryOverviewCfg = require('./states/delivery/overview/overview');
const deliveryCreateCfg = require('./states/delivery/create/create');
const deliveryCreateAmountTpl = require('./states/delivery/create/amount.html');
const deliveryCreateAddressTpl = require('./states/delivery/create/address.html');
const deliveryCreateReviewTpl = require('./states/delivery/create/review.html');
function PhysicalHeroController(GmwPhysical) {
    'ngInject';
    this.showRedeemBars = GmwPhysical.showRedeemBars();
}
PhysicalHeroController.$inject = ['GmwPhysical'];
function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('physical', {
        parent: 'holding.dashboard',
        url: '/physical',
        views: {
            hero: {
                controller: PhysicalHeroController,
                controllerAs: 'physicalHeroCtrl',
                template: heroTemplate,
            },
            main: {
                template: '<div class="_wrapper" ui-view></div>',
            },
        },
    })
        .state('physical.delivery', {
        url: '/delivery',
        views: { '': deliveryCfg },
    })
        .state('physical.delivery.overview', {
        url: '/overview?complete',
        views: { '@physical.delivery': deliveryOverviewCfg },
        resolve: deliveryOverviewCfg.resolve,
    })
        .state('physical.delivery.create', {
        url: '/create',
        views: { '@physical.delivery': deliveryCreateCfg },
        data: {
            flow: deliveryCreateFlowCfg,
        }
    })
        .state('physical.delivery.create.amount', {
        url: '/amount',
        views: { step: { template: deliveryCreateAmountTpl } },
    })
        .state('physical.delivery.create.address', {
        url: '/address',
        views: { step: { template: deliveryCreateAddressTpl } },
    })
        .state('physical.delivery.create.review', {
        url: '/review',
        views: { step: { template: deliveryCreateReviewTpl } },
    });
    $urlRouterProvider.when('/physical/delivery', '/physical/delivery/overview');
    $urlRouterProvider.when('/physical/delivery/create', '/physical/delivery/create/amount');
}
routeConfig.$inject = ['$stateProvider', '$urlRouterProvider'];
ngModule
    .config(routeConfig)
    .service('GmwPhysical', service);
export default ngModule.name;
require('./services/baird');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/physical/index.ts